import React from 'react';
import PropTypes from 'prop-types';
import css from './CwTriggerField.scss';
import CwTextField from '../cwtextfield/CwTextField';
import CwImage from '../cwimage/CwImage';
import cx from 'classnames';
import IconPath from 'src/utils/IconPath';

class CwTriggerField extends React.Component {

  handleTrigger = () => {
    if (this.props.disabled)
      return;
    if (this.props.onTrigger) {
      this.props.onTrigger();
    }
    this.focus();
  };

  focus() {
    this.cwTextField.focus();
  }

  render() {
    const triggerClass = cx({
      [this.props.className]: this.props.className,
      [css.triggerField]: css.triggerField,
      [css.triggerFieldSpace]: this.props.customElement
    });
    const customElementClass = this.props.customElement
      ? this.props.customElementClassName
        ? this.props.customElementClassName
        : css.customElement
      : null;

    let triggerStyle = css.trigger;

    if (this.props.disabled)
      triggerStyle = css.triggerDisabled;
    else if (this.props.invalid)
      triggerStyle = css.triggerInvalid;

    return (
      <div className={triggerClass}>
        {this.props.customElement ? <div className={customElementClass}>
          {this.props.customElement}
        </div> : null}
        <CwTextField
          cwId={this.props.cwId}
          autoComplete="off"
          ref={(input) => this.cwTextField = input}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onChange={this.props.onChange}
          onKeyDown={this.props.onKeyDown}
          onKeyUp={this.props.onKeyUp}
          value={this.props.value}
          disabled={this.props.disabled}
          invalid={this.props.invalid}
          readOnly={this.props.readOnly}
          autoFocus={this.props.autoFocus}
          regex={this.props.regex}
          maxLength={this.props.maxLength}
          placeholder={this.props.placeholder}
        />
        <CwImage className={triggerStyle} src={this.props.triggerIcon} height={24} width={24} onClick={this.handleTrigger} />
      </div>
    );
  }
}

CwTriggerField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Path to trigger icon
   */
  triggerIcon: PropTypes.string,
  /**
   * Callback function that is fired on trigger field keydown
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback function that is fired when trigger field's text changes
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired on trigger field keyup
   */
  onKeyUp: PropTypes.func,
  /**
   * Callback function that is fired on trigger field focus
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired on trigger field blur
   */
  onBlur: PropTypes.func,
  /**
   * Callback function that is fired when trigger is clicked on
   */
  onTrigger: PropTypes.func,
  /**
   * Used to control if trigger field is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable trigger field
   */
  disabled: PropTypes.bool,
  /**
   * Text in textfield
   */
  value: PropTypes.any,
  /**
   * Used to add custom css
   */
  className: PropTypes.string,
  /**
   * Used to set input field to readonly
   */
  readOnly: PropTypes.bool,
  /**
   * Used to control if input field is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Used to add a custom element to the left side of the trigger field
   */
  customElement: PropTypes.any,
  /**
   * Used to add custom css to a custom element on the left side of the trigger field
   */
  customElementClassName: PropTypes.any,
  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: PropTypes.string,
  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: PropTypes.number,
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: PropTypes.string
};

CwTriggerField.defaultProps = {
  triggerIcon: IconPath.get('Action_ExpandDown')
};

export default CwTriggerField;


// WEBPACK FOOTER //
// ./src/components/cwtriggerfield/CwTriggerField.jsx